import config from 'core/config';
import styles from 'theme/features/layout/layout.module.scss';

const Footer = () => (
  <div className={styles.footer}>
    <a href={config.contactUs.url} target="_blank" className={styles['footer__text']} rel="noreferrer">
      Question? Contact #re-lcs-support
    </a>
  </div>
);

export default Footer;
